import { combineReducers } from 'redux';
import authReducer from '../modules/login/redux/authReducer';
import userManagerReducer from '../modules/UserManager/redux/userManagerReducer';
import projectsSetupReducer from '../modules/ProjectSetup/redux/projectsSetupReducer';
import projectStatusReducer from "../modules/ProjectStatuses/redux/projectStatusesReducer";
import departmentReducer from "../modules/ActivityTypes/redux/activityTypesReducer";
import commodityReducer from "../modules/commodity/redux/commodityTypesReducer";
import supplierTypeReducer from "../modules/supplier/redux/supplierTypeReducer";
import materialTypesReducer from "../modules/materialTypes/redux/materialTypesReducer";
import locationsReducer from "../modules/LocationManager/redux/projectsSetupReducer";
import materialTemplatesReducer from "../modules/materialTemplates/redux/materialTemplatesReducer";
import revisionStatusReducer from "../modules/RevisionStatuses/redux/projectStatusesReducer";
import documentControlReducer from "../modules/DocumentControl/redux/documentControlReducer";
import projectReducer from "../modules/Projects/redux/reducer";
import projectDistributionReducer from "../modules/Projects/tableSection/distributionTable/redux/distributionReducer";
import projectRevisionsReducer from "../modules/Projects/tableSection/revisions/redux/revisionsReducer";
import deliveryNoteReducer from "../modules/DeliveryNoteRegister/redux/deliveryNoteReducer";

const rootReducer = combineReducers({
  authReducer: authReducer,
  userManagerReducer: userManagerReducer,
  projectsSetupReducer: projectsSetupReducer,
  projectStatusReducer: projectStatusReducer,
  departmentReducer: departmentReducer,
  commodityReducer: commodityReducer,
  supplierTypeReducer: supplierTypeReducer,
  materialTypesReducer: materialTypesReducer,
  locationsReducer: locationsReducer,
  materialTemplatesReducer: materialTemplatesReducer,
  revisionStatusReducer: revisionStatusReducer,
  documentControlReducer: documentControlReducer,
  projectReducer: projectReducer,
  projectDistributionReducer: projectDistributionReducer,
  projectRevisionsReducer: projectRevisionsReducer,
  deliveryNoteReducer: deliveryNoteReducer,
});

export default rootReducer;